module.exports = __webpack_public_path__ + "static/fibonacci-gameplay-d0e56148a07edcd9eecb78b80d5d3203.gif";